/**
 * @generated SignedSource<<1e6b889c2780b031e5d368428665b113>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyerShipmentRequest_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutShipmentNotes_buyer">;
  readonly " $fragmentType": "BuyerShipmentRequest_buyer";
};
export type BuyerShipmentRequest_buyer$key = {
  readonly " $data"?: BuyerShipmentRequest_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerShipmentRequest_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyerShipmentRequest_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutShipmentNotes_buyer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b86cf44cce16ca49cf48a63360ac11f5";

export default node;
